(() => {
  // ✅ Set this to your TEPO form id (you already have it)
  function getTepoRoot() {
    return document.querySelector('[id^="tcustomizer-form-"]');
  }


  // 0 = first image, 1 = second image, etc.
  const TARGET_MEDIA_INDEX = 1;

  // ✅ Your mapping (paste your full COMBO_URLS object here)
  const COMBO_URLS = {
    "combo: black-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Black.png?v=1769619432",
      "combo: black-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-White.png?v=1769619432",
      "combo: white-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Black.png?v=1769619433",
      "combo: purple-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Black.png?v=1769619432",
      "combo: yellow-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Black.png?v=1769619433",
      "combo: black-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Purple.png?v=1769619433",
      "combo: white-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Purple.png?v=1769619433",

      "combo: green-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_White.png?v=1769619433",
      "combo: pink-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_White.png?v=1769619434",
      "combo: white-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Yellow.png?v=1769619433",
      "combo: black-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Pink.png?v=1769619433",
      "combo: white-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Pink.png?v=1769619433",

      "combo: orange-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Orange.png?v=1769619433",
      "combo: yellow-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Orange.png?v=1769619433",
      "combo: white-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Orange.png?v=1769620232",
      "combo: black-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Orange.png?v=1769619434",

      "combo: red-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Black.png?v=1769619433",
      "combo: yellow-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_White.png?v=1769619433",
      "combo: pink-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Black.png?v=1769619433",
      "combo: red-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_White.png?v=1769619433",

      "combo: blue-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Blue.png?v=1769619433",
      "combo: black-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Red.png?v=1769619433",
      "combo: pink-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Yellow.png?v=1769619433",
      "combo: white-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Green.png?v=1769619433",
      "combo: white-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Red.png?v=1769619433",

      "combo: blue-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Black.png?v=1769619433",
      "combo: orange-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_White.png?v=1769619433",
      "combo: purple-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_White.png?v=1769619434",

      "combo: green-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Green.png?v=1769619434",
      "combo: pink-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Green.png?v=1769619433",
      "combo: black-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Green.png?v=1769619433",

      "combo: purple-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Pink.png?v=1769619433",
      "combo: green-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Pink.png?v=1769619433",

      "combo: blue-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Purple.png?v=1769619434",
      "combo: yellow-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Blue.png?v=1769619434",
      "combo: orange-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Yellow.png?v=1769619433",
      "combo: black-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Blue.png?v=1769619434",

      "combo: green-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Orange.png?v=1769619434",
      "combo: blue-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Green.png?v=1769619435",

      "combo: purple-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Yellow.png?v=1769619434",
      "combo: red-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Blue.png?v=1769619434",
      "combo: green-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Black.png?v=1769619434",

      "combo: red-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Yellow.png?v=1769619434",
      "combo: orange-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Green.png?v=1769619434",
      "combo: orange-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Purple.png?v=1769619434",

      "combo: red-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Green.png?v=1769619434",
      "combo: pink-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Blue.png?v=1769619433",

      "combo: yellow-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Purple.png?v=1769619434",
      "combo: yellow-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Red.png?v=1769619433",
      "combo: green-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Red.png?v=1769619434",

      "combo: blue-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Yellow.png?v=1769619434",
      "combo: black-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Black-Yellow.png?v=1769619434",

      "combo: green-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Blue.png?v=1769619434",
      "combo: yellow-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Yellow.png?v=1769619434",
      "combo: green-yellow": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Yellow.png?v=1769619434",
      "combo: yellow-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Green.png?v=1769619434",

      "combo: purple-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Orange.png?v=1769619434",
      "combo: blue-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Red.png?v=1769619434",
      "combo: orange-black": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Black.png?v=1769619434",

      "combo: orange-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Pink.png?v=1769619434",
      "combo: red-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Orange.png?v=1769619434",
      "combo: pink-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Red.png?v=1769619434",

      "combo: blue-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_White.png?v=1769619434",
      "combo: purple-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Purple.png?v=1769619433",

      "combo: green-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Green-_Purple.png?v=1769619434",
      "combo: red-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Purple.png?v=1769619434",
      "combo: red-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Red.png?v=1769619434",
      "combo: red-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Red-_Pink.png?v=1769619434",

      "combo: yellow-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Yellow-_Pink.png?v=1769619434",
      "combo: blue-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Orange.png?v=1769619435",

      "combo: pink-purple": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Purple.png?v=1769619434",
      "combo: purple-green": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Green.png?v=1769619434",

      "combo: orange-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Red.png?v=1769619434",
      "combo: purple-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Blue.png?v=1769619434",

      "combo: white-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_Blue.png?v=1769619434",
      "combo: pink-orange": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Orange.png?v=1769619434",
      "combo: orange-blue": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Orange-_Blue.png?v=1769619434",
      "combo: blue-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Blue-_Pink.png?v=1769619434",
      "combo: white-white": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/White-_White.png?v=1769619431",
      "combo: pink-pink": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Pink-_Pink.png?v=1769622333",
      "combo: purple-red": "https://cdn.shopify.com/s/files/1/0948/6886/5318/files/Purple-_Red.png?v=1769633541"
  };

  // Default state (can be anything; it will update on first click)
  const state = { text: "white", base: "orange" };

  const norm = (v) =>
    String(v || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9\-]/g, "");

  function cleanLabel(s) {
    return String(s || "")
      .replace(/[+\-]/g, " ")
      .trim()
      .split(" ")[0];
  }

  function comboKey() {
    return `combo: ${norm(state.text)}-${norm(state.base)}`;
  }

  // Grab the Nth media image in the MAIN gallery (not thumbnails)
  function getGalleryImgByIndex(index) {
    const mg = document.querySelector("media-gallery");
    if (!mg) return null;

    const slideImgs = [...mg.querySelectorAll("li.product__media-item img, li[data-media-id] img")]
      .filter((img) => img && img.getAttribute("src"));

    return slideImgs[index] || null;
  }

  // Grab the Nth THUMBNAIL image
  function getThumbImgByIndex(index) {
    const mg = document.querySelector("media-gallery");
    if (!mg) return null;

    const thumbs = [
      ...mg.querySelectorAll(
        'button[aria-controls*="Slide"] img, ' +
          'li.thumbnail-list__item img, ' +
          'slider-component [role="tab"] img, ' +
          '.thumbnail img'
      ),
    ].filter((img) => img && img.getAttribute("src"));

    return thumbs[index] || null;
  }

  function swapImageElTo(img, url) {
    if (!img) return false;

    // Stop responsive/lazy from snapping back
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");

    img.setAttribute("src", url);
    img.src = url;

    if (img.hasAttribute("data-src")) img.setAttribute("data-src", url);
    if (img.hasAttribute("data-master")) img.setAttribute("data-master", url);

    return true;
  }

  function markSecondImage() {
    const img = getGalleryImgByIndex(TARGET_MEDIA_INDEX);
    if (!img) return;
    const wrapper = img.closest(".product__media, li, div");
    if (wrapper) wrapper.classList.add("combo-overlay-target");
  }

  function markSecondThumbnail() {
    const img = getThumbImgByIndex(TARGET_MEDIA_INDEX);
    if (!img) return;
    const wrapper = img.closest("li, button, div");
    if (wrapper) wrapper.classList.add("combo-thumb-overlay-target");
  }

  function updatePreview() {
    const key = comboKey();
    const url = COMBO_URLS[key];
    if (!url) return;

    // MAIN image swap
    swapImageElTo(getGalleryImgByIndex(TARGET_MEDIA_INDEX), url);

    // THUMBNAIL swap
    swapImageElTo(getThumbImgByIndex(TARGET_MEDIA_INDEX), url);
  }

  function bindTepo() {
    const root = getTepoRoot();
    if (!root) return false;

    const fields = () => [...root.querySelectorAll(".tcustomizer-field")];

    root.addEventListener(
      "click",
      (e) => {
        const field = e.target.closest(".tcustomizer-field");
        if (!field) return;

        const idx = fields().indexOf(field);

        const raw =
          e.target.closest("label")?.textContent ||
          e.target.closest("[data-value]")?.getAttribute("data-value") ||
          e.target.textContent ||
          "";

        const label = cleanLabel(raw);
        if (!label) return;

        if (idx === 0) state.text = label;
        if (idx === 1) state.base = label;

        setTimeout(updatePreview, 50);
      },
      true
    );

    // initial run
    setTimeout(() => {
      updatePreview();
      markSecondImage();
      markSecondThumbnail();
    }, 600);

    return true;
  }

  // wait for tepo + gallery
  const start = Date.now();
  const t = setInterval(() => {
    const ok = bindTepo();
    const mg = document.querySelector("media-gallery");
    if (ok && mg) clearInterval(t);
    if (Date.now() - start > 15000) clearInterval(t);
  }, 250);
})();
